
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tak360-livetv",
      function () {
        return require("private-next-pages/tak360-livetv.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tak360-livetv"])
      });
    }
  